import { render, staticRenderFns } from "./VoiceVisualizerNew.vue?vue&type=template&id=7d8d5ae0&scoped=true&"
import script from "./VoiceVisualizerNew.vue?vue&type=script&lang=js&"
export * from "./VoiceVisualizerNew.vue?vue&type=script&lang=js&"
import style0 from "./VoiceVisualizerNew.vue?vue&type=style&index=0&id=7d8d5ae0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d8d5ae0",
  null
  
)

export default component.exports